import TablePayroll from "../TablePayroll";

export const TableItems = (
  filteredDataCount,
  payroll,
  filteredData,
  paginatedData,
  tabKey,
  setFilteredData,
  selectedRow,
  setSelectedRow,
  selectedRowKeys,
  setSelectedRowKeys,
  isPending,
  setIsPending,
  isClicked,
  setIsClicked
) => {
  return [
    {
      label: `All (${filteredDataCount["all"]})`,
      key: "all",
      children: (
        <TablePayroll
          source={payroll}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          isPending={isPending}
          setIsPending={setIsPending}
          isClicked={isClicked}
          setIsClicked={setIsClicked}
        />
      ),
    },
    {
      label: `Ready For Processing (${filteredDataCount[1]})`,
      key: 1,
      children: (
        <TablePayroll
          source={payroll}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          isPending={isPending}
          setIsPending={setIsPending}
          isClicked={isClicked}
          setIsClicked={setIsClicked}
        />
      ),
    },
    {
      label: `Bank Processing (${filteredDataCount[3]})`,
      key: 3,
      children: (
        <TablePayroll
          source={payroll}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          isPending={isPending}
          setIsPending={setIsPending}
          isClicked={isClicked}
          setIsClicked={setIsClicked}
        />
      ),
    },
    {
      label: `Disbursed (${filteredDataCount[4]})`,
      key: 4,
      children: (
        <TablePayroll
          source={payroll}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          isPending={isPending}
          setIsPending={setIsPending}
          isClicked={isClicked}
          setIsClicked={setIsClicked}
        />
      ),
    },
    {
      label: `Cancelled (${filteredDataCount[0]})`,
      key: 0,
      children: (
        <TablePayroll
          source={payroll}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          isPending={isPending}
          setIsPending={setIsPending}
          isClicked={isClicked}
          setIsClicked={setIsClicked}
        />
      ),
    },
  ];
};